import React from 'react';

/**
 * Skeleton for the event/week selector row (REST-first Suspense fallback).
 */
export function EventSelectorSkeleton() {
  return (
    <div
      className="flex gap-2 p-2 c7-app-bg border-b border-[var(--c7-border-color)] overflow-x-hidden"
      aria-hidden
    >
      {[1, 2, 3, 4, 5].map((i) => (
        <div
          key={i}
          className="h-10 w-16 md:w-20 rounded animate-pulse bg-[var(--c7-muted)] opacity-70 flex-shrink-0"
        />
      ))}
    </div>
  );
}
